module.exports = __webpack_public_path__ + "04b6f0e09212a7b5162410e05548e97d.png";